export default __webpack_public_path__ + "img/lan.bceb1ad.svg";